// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__15HoQ","large":"styles_large__1f-9V"};